import { Link } from 'react-router-dom';
import { adsEnabled } from '../../ads/config';
import { LEGAL } from './config';
import { Contact, LegalPage } from './LegalPage';

export function TermsPage() {
  return (
    <LegalPage title="Terms of Service">
      <p className="legal__lead">
        These terms apply when you use SuperFunUBG, a free website of browser games run by {LEGAL.operator} (“we”). By using the site you agree to them. If you don’t agree,
        please don’t use the site.
      </p>

      <h2>Using the games</h2>
      <ul>
        <li>
          The games are free and need no account{adsEnabled() ? ', and the site is supported by ads from third parties such as Google' : ''}. You may play them for personal,
          non-commercial fun.
        </li>
        <li>If you’re under the age required to agree to these terms where you live, please use the site with a parent’s or guardian’s permission.</li>
        <li>
          Follow the rules of the network and device you’re using. If your school, workplace or another network operator doesn’t allow games, respect that. SuperFunUBG doesn’t provide any way
          to get around network filters or restrictions, and you must not use it to try.
        </li>
      </ul>

      <h2>Fair play</h2>
      <p>Don’t:</p>
      <ul>
        <li>flood, overload, attack or probe the site;</li>
        <li>interfere with other people’s ability to use the site.</li>
      </ul>
      <p>We may limit or block connections that break these rules or harm the service, without notice.</p>
      {adsEnabled() && <p>Don’t click ads deliberately or repeatedly to generate fake clicks, or use tools that do.</p>}

      <h2>Availability</h2>
      <p>
        We try to keep the site running, but features can change or be removed at any time. Games keep working in your browser once a page has loaded, but we don’t guarantee any game will always be available.
      </p>

      <h2>Your privacy</h2>
      <p>
        How we handle information is described in our <Link to="/privacy">Privacy Policy</Link>.
      </p>

      <h2>Our content</h2>
      <p>
        The games, artwork, logo, code and text on SuperFunUBG belong to {LEGAL.operator} or its licensors. You may not copy, resell or republish them except as the law allows, or with our
        permission. The site also uses open-source software and fonts under their own licenses, listed in our{' '}
        <a href="/third-party-licenses.txt">open-source licenses</a>.
      </p>

      <h2>Original games</h2>
      <p>
        Our games are original works. Some are inspired by popular game genres, but their names, characters, artwork, music and text are our own. SuperFunUBG is not affiliated with,
        sponsored by or endorsed by any other game publisher or developer.
      </p>

      <h2>Copyright and trademark concerns</h2>
      <p>
        We respect other people’s rights. If you believe something on SuperFunUBG infringes your copyright or trademark, contact us at <Contact /> with: what work or mark you own, which
        page or game you’re concerned about, how to reach you, and a statement that you believe in good faith the use isn’t authorized. We review every notice promptly and remove or change
        material when it’s appropriate.
      </p>

      <h2>No warranty</h2>
      <p>
        The site is provided “as is” and “as available”, without warranties of any kind, express or implied, including fitness for a particular purpose and non-infringement, to the extent
        the law allows.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        To the extent the law allows, we aren’t liable for indirect, incidental or consequential damages, or for any loss of data or interruption, arising from your use of the site. Nothing in these terms limits rights you have under laws that can’t be waived.
      </p>

      <h2>Changes to these terms</h2>
      <p>We may update these terms. The new version applies from the effective date shown above. Continuing to use the site after a change means you accept it.</p>

      {LEGAL.jurisdiction && (
        <>
          <h2>Governing law</h2>
          <p>These terms are governed by the laws of {LEGAL.jurisdiction}, except where the law of your home country requires otherwise.</p>
        </>
      )}

      <h2>Contact</h2>
      <p>
        Questions about these terms: <Contact />
      </p>
    </LegalPage>
  );
}
